"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomObserver = void 0;
var vue_model_1 = require("./vue-model");
var helpers_1 = require("./helpers");
var vue_model_observability_1 = require("./vue-model-observability");
var model_js_1 = require("@cognitoforms/model.js");
var VueInternals = vue_model_1.VueModel._VueInternals;
if (!VueInternals.Observer) {
    throw new Error("Vue's Observer constructor has not yet been obtained, be sure to call Vue.use(VueModel).");
}
var Observer = VueInternals.Observer;
/**
 * A subclass of Vue's internal Observer class that is responsible
 * for managing its own access/change events for properties rather than
 * walking the object's own properties
 */
var CustomObserver = /** @class */ (function (_super) {
    __extends(CustomObserver, _super);
    function CustomObserver(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        var _this = _super.call(this, value, shallow, mock) || this;
        _this.propertyDeps = {};
        return _this;
    }
    /**
     * Gets (or creates) a `Dep` object for a property of the given name
     * The `Dep` object will be stored internally by the observer, using
     * the given target property name as a key
     * @param propertyName The target property name
     * @param create If true, create the `Dep` object if it doesn't already exist
     */
    CustomObserver.prototype.getPropertyDep = function (propertyName, create) {
        if (create === void 0) { create = false; }
        var propertyDep;
        var Dep = VueInternals.Dep;
        var propertyDeps = this.propertyDeps;
        if ((0, helpers_1.hasOwnProperty)(propertyDeps, propertyName) && propertyDeps[propertyName] instanceof Dep) {
            propertyDep = propertyDeps[propertyName];
        }
        else if (create) {
            propertyDep = new Dep();
            Object.defineProperty(propertyDeps, propertyName, {
                configurable: true,
                enumerable: true,
                value: propertyDep,
                writable: true
            });
        }
        return propertyDep;
    };
    /**
     * Emulate's Vue's getter logic in `defineReactive()`
     * @param propertyName The property being accessed
     * @param value The current property value
     */
    CustomObserver.prototype.onPropertyAccess = function (propertyName, value) {
        var Dep = VueInternals.Dep;
        // Attach dependencies if something is watching
        if (Dep.target) {
            // Get or initialize the `Dep` object
            var propertyDep = this.getPropertyDep(propertyName, true);
            // Let an active observer target know that the property was accessed and is a dependency
            propertyDep.depend();
            var childOb = (0, vue_model_observability_1.observeEntity)(value);
            if (childOb) {
                childOb.dep.depend();
            }
            if (Array.isArray(value)) {
                // Track dependency on children as well (creating entity observer as needed)
                (0, vue_model_observability_1.dependChildArray)(value);
            }
        }
    };
    /**
     * Emulate's Vue's setter logic in `defineReactive()`
     * @param propertyName The property being accessed
     * @param newValue The new property value
     */
    CustomObserver.prototype.onPropertyChange = function (propertyName, newValue) {
        // Get or initialize the `Dep` object
        var propertyDep = this.getPropertyDep(propertyName, true);
        // Make sure a new value that is an entity is observable
        if (newValue && newValue instanceof model_js_1.Entity) {
            (0, vue_model_observability_1.observeEntity)(newValue).ensureObservable();
        }
        // Notify of property change
        propertyDep.notify();
    };
    return CustomObserver;
}(Observer));
exports.CustomObserver = CustomObserver;
